module.exports = __webpack_public_path__ + "static/media/Ipod Docking.6833dbd1.svg";